import { Map } from 'immutable';

export const Features = Map({
    default: Map({
        values: [true, false],
        defaultValue: true,
    }),
    addMoreServices: Map({
        values: [
            {
                name: 'Control one service',
                value: false,
            },
            {
                name: 'Experiment multiple services',
                value: true,
            },
        ],
        defaultValue: {
            name: 'Control one service',
            value: false,
        },
    }),
});



// WEBPACK FOOTER //
// ./src/data/Features.js